<template>
  <div class="loader">
    <!--
      @slot overrides the complete default implementation.
        @binding {boolean} loading the loading state
        @binding {object} error contains the error
        @binding {object} data contains the provided data
    -->
    <slot :data="data" :error="error" :loading="loading">
      <!-- @slot additional loading state -->
      <slot name="loading_additional" v-if="loading">
      </slot>

      <!--
        @slot content the content state
          @binding {object} data contains the provided data
       -->
      <slot :data="data" name="content" v-if="!error && (!loading || (initLoaded && overlay )) ">
        {{ data }}
      </slot>

      <!-- @slot the loading state -->
      <slot name="loading" v-if="loading">
        <v-container :style="fullPageStyle" :class="['loading', {overlay: initLoaded && overlay }]" fill-height fluid
                     ma-0>
          <v-row align="center" justify="center">

            <fin-logo-sign dark loading v-if="smallLoader"/>
            <fin-logo-full dark loading v-else/>
          </v-row>
        </v-container>
      </slot>
      <!--
        @slot the error state
          @binding {object} error contains the error
      -->
      <slot :error="error" name="error" v-else-if="error">
        <v-container :style="fullPageStyle" fill-height fluid ma-0>
          <v-row align="center" justify="center">
            <fin-error-msg msg="Beim Laden ist ein Fehler aufgetreten. Versuch es bitte später nochmals."/>
          </v-row>
        </v-container>
      </slot>
    </slot>
  </div>
</template>

<script>
/**
 * Component description
 */
import {isEqual} from 'lodash-es'
import FinLogoFull from '@/components/common/logo/LogoFull/index'
import FinErrorMsg from '@/components/common/ErrorMsg'
import DataFetcher from "@/components/common/DataLoader/DataFetcher"
import FinLogoSign from "@/components/common/logo/LogoSign"

export default {
  name: 'FinDataLoader',
  components: {FinLogoSign, FinErrorMsg, FinLogoFull},
  props: {
    /** Value, Promise or Function (that returns a Promise or value), the result is used for the content area (see data) */
    resolver: {},
    /** Additional params for the resolver function. The resolver is executed again at changes of this params */
    params: {},
    /** Put this at true to show the loading and error in fullheight */
    fullpage: {
      type: Boolean
    },
    overlay: {
      type: Boolean
    },
    smallLoader: {
      type: Boolean
    },
    dataAdapter: {
      type: Function
    },
    showLoading: {
      type: Boolean
    },
  },
  data() {
    return {
      initLoaded: false,
      data: null,
      working: false,
      error: null
    }
  },
  beforeMount() {
    this._fetchData()
  },
  watch: {
    params(val, old) {
      if(!isEqual(val, old)){
        this._fetchData()
      }
    },
    resolver() {
      this._fetchData()
    }
  },
  computed: {
    loading(){
      return this.showLoading || this.working
    },
    fullPageStyle() {
      return this.fullpage ? {'min-height': `calc( 100vh - ${this.$vuetify.application.top}px)`} : {}
    }
  },
  methods: {
    handleError(e) {
      console.error(e)
      this.error = e
      /** Triggers at a fail of the promise, with the exception as parameter */
      this.$emit('error', e)
    },
    async _fetchData() {
      this.error = null
      this.working = true
      try {
        this.data = await DataFetcher.fetchData(this.resolver, this.params, this.dataAdapter, (val) => {
          this.data = val
          this.$emit('input', this.data)
          this.initLoaded = true
        })
      } catch (e) {
        this.handleError(e)
      }

      this.$emit('input', this.data)
      this.working = false
      this.initLoaded = true
      this.$nextTick(() => this.$emit('loaded'))
    }
  }
}
</script>

<style scoped lang="scss">
.loader {
  position: relative;
}

.loading {
  overflow: hidden;

  &.overlay {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.5);;
  }
}
</style>
